import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import { Button } from '@material-ui/core'
import { noop } from 'lodash'

import api from 'common/api'

import RegisterModal from './RegisterModal'

export class Modal extends React.Component {
  static propTypes = {
    show: PropTypes.bool,
    eventId: PropTypes.string.isRequired,
    highSchoolName: PropTypes.string.isRequired,
    onEventChange: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    allowRepMeeting: PropTypes.bool,
    placeName: PropTypes.string,
  }
  static defaultProps = {
    show: false,
  }
  register = (placeName) => {
    const { eventId, onClose, onEventChange } = this.props
    const requestBody = placeName === this.props.placeName ? {} : { PlaceName: placeName }
    api
      .post(`/api/highschools/visits/${eventId}/register`, requestBody)
      .then(() => {
        onEventChange()
        onClose()
      })
      .catch(noop)
  }
  render() {
    return (
      <RegisterModal
        show={this.props.show}
        title="Confirm Registration"
        onClose={() => this.props.onClose()}
        onConfirm={this.register}
        allowRepMeeting={this.props.allowRepMeeting}
        placeName={this.props.placeName}
      >
        <Fragment>
          <span>
            Are you sure you want to register for a visit to <strong>{this.props.highSchoolName}</strong>?
          </span>
          <div className="shared-information-label">
            Registration for this event will share your contact information with this school.
          </div>
        </Fragment>
      </RegisterModal>
    )
  }
}
export class Trigger extends React.Component {
  static propTypes = {
    onOpen: PropTypes.func.isRequired,
  }
  render() {
    return (
      <Button
        variant="contained"
        color="primary"
        size="small"
        onClick={() => this.props.onOpen()}
      >
        Register
      </Button>
    )
  }
}
